import React from "react";
import { connect } from "react-redux";
import { Formik } from "formik";
import { Form } from "react-bootstrap";

import { TextInput, EditorField, SubmitButton, DateTimeInput, PhoneInput } from "components/forms";
import { editFunderContact, fetchFunderContactAffiliationsFromFunder, unsetShouldSave } from "actions";
import { activeFunderIdSelector, shouldSaveSelector } from "reducers";
import { showModal } from "../../actions";
import Collapsible from "../../components/Collapsible";
import * as notifications from "../../notifications";
import { getFromFunderDetail } from "../../utils";

const FunderContactDetailForm = ({ funderContactInfo, activeFunderId, ...props }) => {
  if (!funderContactInfo) {
    // Still didn't fetch data
    return null;
  }

  const fromFunderDetail = getFromFunderDetail();
  const submitRef = React.useRef();

  React.useEffect(() => {
    if (props.shouldSave) {
      submitRef.current.click();
    }
  }, [props.shouldSave]);

  return (
    <Formik
      enableReinitialize
      initialValues={funderContactInfo}
      onSubmit={async (values, { setSubmitting, setErrors }) => {
        try {
          await props.editFunderContact(funderContactInfo.id, values);
          fromFunderDetail && props.fetchFunderContactAffiliationsFromFunder(activeFunderId);
          notifications.success("Saved");
        } catch (error) {
          setErrors(error.response.data);
          notifications.error("Error editing Contact");
        }
        props.unsetShouldSave();
        setSubmitting(false);
      }}
    >
      {({ handleSubmit, values, setFieldValue }) => {
        return (
          <Form onSubmit={handleSubmit} className={"form shadowed"} {...props}>
            <Collapsible title="Counter Party Contact Information">
              <Form.Row>
                <TextInput label="First Name" name="first_name" />
                <TextInput label="Last Name" name="last_name" />
                <TextInput label="Nick Name" name="nickname" />
              </Form.Row>
              <Form.Row>
                <PhoneInput label="Mobile Phone" name="mobile_phone" />
                <TextInput label="Personal Email" lowercase={true} name="personal_email" />
                <TextInput label="Linked-In" name="linkedin" />
              </Form.Row>
              <Form.Row>
                <DateTimeInput label="Date Created" name="date_created" disabled />
                <DateTimeInput label="Last Edit Date" name="last_edit_date" disabled />
              </Form.Row>
              <Form.Row>
                <EditorField label="Notes" name="notes" />
              </Form.Row>
            </Collapsible>
            <SubmitButton innerRef={submitRef} style={{ display: fromFunderDetail ? "block" : "none" }} />
          </Form>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = state => {
  return {
    shouldSave: shouldSaveSelector(state),
    activeFunderId: activeFunderIdSelector(state),
  };
};

export default connect(mapStateToProps, {
  editFunderContact,
  showModal,
  unsetShouldSave,
  fetchFunderContactAffiliationsFromFunder,
})(FunderContactDetailForm);
